module.exports = __webpack_public_path__ + "media/images/video_buddy_spido-b37f9e1e35d1acbc3bff9ff25c4ba45e.jpg";